import React from 'react';

/**
 * Buy Me a Coffee button component
 * Used in both desktop and mobile footer layouts
 */
export default function BuyMeACoffeeButton({ 
  className = '', 
  showTooltip = false, 
  onMouseEnter, 
  onMouseLeave 
}) {
  return (
    <a 
      href="https://buymeacoffee.com/lutherstudio" 
      target="_blank" 
      rel="noopener noreferrer"
      className={`bmc-custom-btn ${className} ${showTooltip ? 'show-tooltip' : ''}`}
      data-tooltip="Keep Colority ad-free 💜"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <img src="/buymeacoffee.png" alt="Buy me a coffee" className="bmc-icon" />
      <span>Buy me a coffee</span>
    </a>
  );
}

